var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBottom = function SvgArrowBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.705 10.27a1 1 0 0 0-1.41 0L9 12.75V1a1 1 0 0 0-2 0v11.755l-2.295-2.5a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.435l3.645 3.85a1.5 1.5 0 0 0 2.12 0l3.645-3.85a1.002 1.002 0 0 0 0-1.42Z"
  })));
};
export default SvgArrowBottom;